console.log('components');


import { handleMarquee } from "./components/marquee";
handleMarquee();

import { yMap } from "./components/yMap";
yMap();

import { headerAnim } from './components/header-anim';

headerAnim('.header');